// extracted by mini-css-extract-plugin
export default {"privacity":"listPrivacy_privacity__T2wMv"};